import React, { useRef, useState } from "react";
import { Box, IconButton, useMediaQuery } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ProcessedUltrasoundImage } from "../../../utility/interfaces/patientMasterDataInterface";
import { Navigation, Thumbs } from "swiper/modules";
import styles from "./FullScreenGallery.module.scss";
import CustomSwiper from "../../../components/v2/custom-swiper-layout/CustomSwiper";

interface FullScreenGalleryProps {
  images: ProcessedUltrasoundImage[];
  open: boolean;
  onClose: () => void;
  initialIndex?: number;
}

const FullScreenGallery: React.FC<FullScreenGalleryProps> = ({
  images,
  open,
  onClose,
  initialIndex = 0,
}) => {
  const swiperRef = useRef<any>(null);
  const [activeIndex, setActiveIndex] = useState(initialIndex);

  const isMobile = useMediaQuery("(max-width: 900px)");

  if (!open) return null;
  return (
    <Box className={styles.fullscreenGallery}>
      <IconButton onClick={onClose} className={styles.closeButton}>
        <CloseIcon fontSize="medium" />
      </IconButton>

      <Box className={styles.mainSwiperWrapper}>
        <CustomSwiper
          items={images}
          modules={[Navigation, Thumbs]}
          swiperOptions={{
            navigation: true,
            centeredSlides: true,
            centerInsufficientSlides: true,
            slidesPerView: 1,
          }}
          onSwiperInit={(swiper) => {
            swiperRef.current = swiper;
            swiper.slideTo(initialIndex, 0);
            setActiveIndex(initialIndex);
          }}
          onSlideChange={(swiper) => {
            setActiveIndex(swiper.activeIndex);
          }}
          renderSlide={(img) => (
            <img
              src={img.imageUrl}
              alt={img.imageName}
              className={styles.mainImage}
            />
          )}
          className={styles.mainSwiper}
        />
      </Box>

      {!isMobile && (
        <Box className={styles.thumbsSwiperWrapper}>
          <CustomSwiper
            items={images}
            modules={[Thumbs]}
            swiperOptions={{
              slidesPerView: 6,
              spaceBetween: 10,
              watchSlidesProgress: true,
              centeredSlides: false,
              centerInsufficientSlides: true,
            }}
            onSlideClick={(index) => {
              swiperRef.current?.slideTo(index);
              setActiveIndex(index);
            }}
            renderSlide={(img, index) => (
              <img
                src={img.imageUrl}
                alt={img.imageName}
                className={`${styles.thumbImage} ${
                  index === activeIndex ? styles.activeThumb : ""
                }`}
              />
            )}
            className={styles.thumbsSwiper}
          />
        </Box>
      )}
    </Box>
  );
};

export default FullScreenGallery;

